@if (currentOptions) {
  <div class="fee-spoiler-container">
    <!-- Fee Toggle Header -->
    <div class="fee-spoiler-toggle" (click)="toggleFeeSelection()">
      <div class="fee-summary-left">
        <kc-icon iconClass="icon-chain" size="sm" color="var(--kaspa-20)" />
        <span class="fee-label">
          @if (totalTransactionsMass && totalTransactionsMass.length > 1) {
            Estimated Total Fees:
          }
          @if (totalTransactionsMass && totalTransactionsMass.length == 1) {
            Total Fee:
          }
        </span>
        <div class="fee-value">
          @if (totalTransactionsMass && totalTransactionsMass.length > 1) {
            <span>≈{{ getEstimatedTotalFees() | sompiToNumber }}</span>
            <!-- Always show kaspa icon for fees -->
            <kc-icon iconClass="icon-kaspa-coin" size="sm" />
          }
          @if (totalTransactionsMass && totalTransactionsMass.length == 1) {
            @if (additionalPriorityFee === undefined) {
              <span>Not selected</span>
            }
            @if (additionalPriorityFee !== undefined) {
              <span>{{ getEstimatedTotalFees() | sompiToNumber }}</span>
              <!-- Always show kaspa icon for fees -->
              <kc-icon iconClass="icon-kaspa-coin" size="sm" />
            }
          }
        </div>
      </div>
      <div class="fee-spoiler-chevron">
        <kc-icon
          [iconClass]="
            showPriorityFeeSelection ? 'icon-chevron-up' : 'icon-chevron-down'
          "
          size="sm"
          color="var(--gray-60)"
        />
      </div>
    </div>
    <!-- Fee Selection Content (Collapsible) -->
    <div
      class="fee-selection-content"
      [@slideDown]="showPriorityFeeSelection ? 'open' : 'closed'"
    >
      <div class="fee-selection-inner">
        <!-- Fee Options -->
        <div class="fee-options-grid">
          @for (option of currentOptions | keyvalue; track option) {
            <div
              class="fee-option-card"
              [class.selected]="selectedOption === option.key"
              (click)="selectOption(option.key)"
            >
              <div class="option-title">{{ option.key | titlecase }}</div>
              <div class="option-fee">
                <span>{{ option.value.priorityFee | sompiToNumber }}</span>
                <!-- Always show kaspa icon for fees -->
                <kc-icon iconClass="icon-kaspa-coin" size="sm" />
              </div>
              <div class="option-time">
                ~{{ option.value.estimatedSeconds.toFixed(1) }}s
              </div>
            </div>
          }
        </div>
        <!-- Custom Fee -->
        <div class="custom-fee-section">
          <div
            class="custom-fee-card"
            [class.selected]="selectedOption === 'custom'"
            (click)="selectOption('custom')"
          >
            <div class="custom-fee-header">
              <span class="custom-fee-title">Custom Fee</span>
            </div>
            <div class="custom-fee-input">
              <kc-number-input
                placeholder="Enter amount"
                [(ngModel)]="customFee"
                (valueChange)="selectOption('custom')"
              >
                <div rightSideSlot class="input-icon">
                  <!-- Always show kaspa icon for fees -->
                  <kc-icon iconClass="icon-kaspa-coin" size="sm" />
                </div>
              </kc-number-input>
            </div>
          </div>
        </div>
        <!-- Fee Details -->
        <div class="fee-details-section">
          <div class="fee-detail-row">
            <span class="detail-label">Minimum transaction fee:</span>
            <div class="detail-value">
              <span>{{
                transactionMass! * minimumFeeMultiplier | sompiToNumber
              }}</span>
              <!-- Always show kaspa icon for fees -->
              <kc-icon iconClass="icon-kaspa-coin" size="sm" />
            </div>
          </div>
          <div class="fee-detail-row">
            <span class="detail-label">Additional Priority fee:</span>
            <div class="detail-value">
              @if (additionalPriorityFee === undefined) {
                <span>Not selected</span>
              }
              @if (additionalPriorityFee !== undefined) {
                <span>{{ additionalPriorityFee | sompiToNumber }}</span>
                <!-- Always show kaspa icon for fees -->
                <kc-icon iconClass="icon-kaspa-coin" size="sm" />
              }
            </div>
          </div>
          @if (getAdditionalCommitActionPrice() > 0) {
            <div class="fee-detail-row">
              <span class="detail-label">Protocol Action Fee:</span>
              <div class="detail-value">
                <span>{{
                  getAdditionalCommitActionPrice() | sompiToNumber
                }}</span>
                <!-- Always show kaspa icon for fees -->
                <kc-icon iconClass="icon-kaspa-coin" size="sm" />
              </div>
            </div>
          }
          @if (totalTransactionsMass && totalTransactionsMass.length > 1) {
            <div class="fee-detail-row">
              <span class="detail-label">Number Of Transactions:</span>
              <div class="detail-value">
                <span>{{ totalTransactionsMass!.length }}</span>
                <!-- No icon needed for transaction count -->
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

<!-- Loading State -->
@if (!currentOptions) {
  <div class="fee-loading">
    <p>Loading Priority Fees...</p>
  </div>
}
